module.exports = __webpack_public_path__ + "img/store_LINE_brown.fe45a3e6.svg";